import { saveSubmission } from './databaseService';
import { savePhotoStudioAppointment } from './photoStudioService';
import { createErrorResponse } from '../utils/errorHandler';

/**
 * Submits form data to appropriate service with standardized error handling
 * @param {Object} formData - The form data to submit
 * @param {string} formType - Type of form (photoStudio)
 * @returns {Promise} - Promise with standardized result
 */
export const submitForm = async (formData, formType) => {
  try {
    if (formType === 'photoStudio') {
      // Use ONLY dedicated photo studio service - no double saves
      return await savePhotoStudioAppointment(formData);
    } else {
      // Use general database service
      return await saveSubmission(formData, formType);
    }
  } catch (error) {
    console.error('Form submission error:', error);
    return createErrorResponse(error);
  }
};